import React, { Component } from 'react'
import { connect } from 'react-redux'
import TimeCounter from '../containers/TimeCounter'

const mapStateToProps = (state) => {
     return {
        InfoUsers: state.informationusers,
     };
     
   }


 class ScreenBlock extends Component {
        constructor(props) {
            super(props);
            this.state = {};
        }

        LogoutSup(){
          document.getElementById("logoutclicado").click();
        }

render(){
    const { InfoUsers } = this.props;

    return(
        <div className={InfoUsers.blockscreen ? "modal-overlay modal__pausa-errada active":"modal-overlay modal__pausa-errada"}>
          <div className="modal-box">
            <div className="modal-box__header">
                <p className="modal-box__title">Bloqueado</p>
                {/* <span className="modal-box__close-btn btn-close__logout"><i className="material-icons modal-box__close-icon">close</i></span> */}
            </div>
            <div className="modal-box__content">
                <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn%3AANd9GcTfQiQbbOcOXy7XEGHKRqZZzjyvmcPGL3sWPQ&usqp=CAU" alt="" className="modal-box__img" />
                <h3 className="modal-box__warning is-poppins pd-0">Oops… <em className="is-poppins is-poppins--bold">parece que você está bloqueado.</em></h3>
                {
                  (() => {
                            if(InfoUsers.typeblock === '1'){
                              return <p className="modal-box__message">Você ultrapassou o tempo máximo de atraso em <TimeCounter key={InfoUsers.id} horario={InfoUsers.timeexceed} /> para login.</p>
                            }
                  })()
                }
                <a href="/login" style={{'display':'none'}} id="logoutclicado" className="logout btn btn-outline">SAIR</a>
                {/* <p className="modal-box__message">
                  Solicite ao seu gestor para efetue o desbloqueio de seu login
                </p> */}
                <p className="modal-box__message">Razão do bloqueio: {InfoUsers.reasonblock}</p>
                <a onClick={event => this.LogoutSup(event)} className="modal-box__return-btn btn-return__pausa-errada">Sair do IngWeb</a>
              </div>
            </div>
        </div>
    )}
}

export default connect(
    mapStateToProps,
    null
  )(ScreenBlock);